/* brain-help.js: the zero-AI help widget (#357). Brand-neutral: every word a shopper reads comes from the
 * snippet (brain-help.liquid) or from the brain's answer. Talks to <data-endpoint>/order and /contact only.
 * Open from anywhere with a link to #help, #help-track or #help-talk. */
(function () {
  var root = document.getElementById('brain-help');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var STORE = root.getAttribute('data-store');
  var API = root.getAttribute('data-endpoint');
  var ERR = root.getAttribute('data-err') || 'Something went wrong. Please try again.';
  var bubble = root.querySelector('.bh-bubble');
  var back = root.querySelector('.bh-back');
  var views = root.querySelectorAll('.bh-view');
  var body = root.querySelector('.bh-body');
  var current = 'home';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function show(name) {
    current = name;
    for (var i = 0; i < views.length; i++) views[i].hidden = views[i].getAttribute('data-view') !== name;
    back.hidden = name === 'home';
    body.scrollTop = 0;
    var first = root.querySelector('.bh-view[data-view="' + name + '"] input');
    if (first && window.innerWidth > 600) setTimeout(function () { first.focus(); }, 30);
  }
  function open(view) {
    liftAbovePreviewBar();
    root.classList.add('bh-open'); bubble.setAttribute('aria-expanded', 'true');
    show(view || current);
  }
  function shut() { root.classList.remove('bh-open'); bubble.setAttribute('aria-expanded', 'false'); queueDodge(); }

  bubble.addEventListener('click', function () { open(); });
  root.querySelector('.bh-close').addEventListener('click', shut);
  back.addEventListener('click', function () { show('home'); });
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-go]') : null;
    if (t && root.contains(t)) show(t.getAttribute('data-go'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('bh-open')) shut(); });
  function fromHash() {
    var m = /^#help(?:-(track|answers|talk))?$/.exec(location.hash);
    if (m) open(m[1] || 'home');
  }
  window.addEventListener('hashchange', fromHash);
  fromHash();

  function post(path, data) {
    data.store = STORE;
    return fetch(API + path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(data), mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: ERR }; }); });
  }
  function card(cls, html) { return '<div class="bh-card ' + cls + '">' + html + '</div>'; }

  function orderHtml(o) {
    var h = '<div class="bh-card bh-tone-' + esc(o.tone) + '">';
    h += '<div class="bh-status"><span class="bh-dot"></span>' + esc(o.headline) + '</div>';
    h += '<div class="bh-sub">' + esc(o.order) + (o.placed ? ' · ' + esc(o.placed) : '') + '</div>';
    h += '<p>' + esc(o.detail) + '</p>';
    if (o.timeline) h += '<p>' + esc(o.timeline) + '</p>';
    if (o.money) h += '<p>' + esc(o.money) + '</p>';
    for (var r = 0; r < (o.returns || []).length; r++) h += '<p>' + esc(o.returns[r]) + '</p>';
    if (o.shipments && o.shipments.length) {
      h += '<div class="bh-h">Tracking</div>';
      for (var i = 0; i < o.shipments.length; i++) {
        var s = o.shipments[i];
        h += '<div class="bh-ship"><div>' + esc(s.state) + '</div>';
        if (s.lastScan) h += '<div class="bh-sub">' + esc(s.lastScan) + '</div>';
        h += '<div>' + esc(s.carrier) + ' ' + (s.url ? '<a href="' + esc(s.url) + '" target="_blank" rel="noopener">' + esc(s.tracking) + '</a>' : esc(s.tracking)) + '</div></div>';
      }
    }
    if (o.items && o.items.length) {
      h += '<div class="bh-h">Items</div><ul class="bh-items">';
      for (var j = 0; j < o.items.length; j++) {
        var it = o.items[j];
        var t = esc(it.title) + (it.size ? ' · ' + esc(it.size) : '') + (it.qty > 1 ? ' × ' + it.qty : '');
        h += '<li>' + (it.refunded ? '<s>' + t + '</s>' : t) + '</li>';
      }
      h += '</ul>';
    }
    return h + '</div>';
  }

  var forms = root.querySelectorAll('.bh-form');
  for (var f = 0; f < forms.length; f++) (function (form) {
    var kind = form.getAttribute('data-kind');
    var out = form.parentNode.querySelector('.bh-result');
    var btn = form.querySelector('.bh-btn');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = {};
      var els = form.querySelectorAll('input,textarea');
      for (var i = 0; i < els.length; i++) d[els[i].name] = els[i].value.trim();
      btn.disabled = true; out.innerHTML = '';
      post(kind === 'order' ? '/order' : '/contact', d).then(function (j) {
        if (!j || !j.ok) { out.innerHTML = card('bh-err', '<p>' + esc((j && j.error) || ERR) + '</p>'); return; }
        if (kind === 'order') { out.innerHTML = orderHtml(j.order); out.scrollIntoView({ block: 'nearest' }); return; }
        var tpl = form.parentNode.querySelector('template.bh-sent');
        out.innerHTML = tpl ? tpl.innerHTML : card('bh-ok', '<p>OK</p>');
        if (!j.emailed) { var m = out.querySelector('.bh-sent-mail'); if (m) m.remove(); }
        form.hidden = true;
      }).catch(function () { out.innerHTML = card('bh-err', '<p>' + esc(ERR) + '</p>'); })
        .then(function () { btn.disabled = false; });
    });
  })(forms[f]);

  /* Stay off the theme preview bar, the storefront's own wide CTAs and open drawers (same rules the old
   * chat bubble learned the hard way, 2026-09-03). */
  function liftAbovePreviewBar() {
    var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    root.style.setProperty('--bh-lift', (bar ? Math.ceil(bar.getBoundingClientRect().height) : 0) + 'px');
  }
  var MODAL = 'dialog[open], cart-drawer.active, cart-drawer[open], .drawer.active, .cart-drawer.active, .modal.active, [aria-modal="true"]';
  function modalOpen() {
    var nodes = document.querySelectorAll(MODAL), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (root.contains(n)) continue;
      var cs = window.getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) < 0.1) continue;
      var r = n.getBoundingClientRect();
      if (r.width < vw * 0.5 || r.height < vh * 0.4 || r.bottom <= 0 || r.top >= vh) continue;
      return true;
    }
    return false;
  }
  var pending = false;
  function dodge() {
    pending = false;
    if (root.classList.contains('bh-open')) { root.classList.remove('bh-hushed'); root.style.setProperty('--bh-dodge', '0px'); return; }
    if (modalOpen()) { root.classList.add('bh-hushed'); return; }
    root.classList.remove('bh-hushed');
    root.style.setProperty('--bh-dodge', '0px');
    var base = bubble.getBoundingClientRect();
    if (!base.width) return;
    var vw = window.innerWidth, vh = window.innerHeight, best = null;
    var nodes = document.querySelectorAll('a,button,[role="button"],[type="submit"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (root.contains(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.4 || r.height < 28) continue;
      if (r.bottom < base.top || r.top > base.bottom || r.right < base.left || r.left > base.right) continue;
      if (!best || r.top < best.top) best = r;
    }
    if (!best) return;
    var lift = Math.min(Math.ceil(vh - best.top) + 12, Math.max(0, vh - base.height - 24));
    root.style.setProperty('--bh-dodge', (lift > 0 ? lift : 0) + 'px');
  }
  function queueDodge() { if (pending) return; pending = true; setTimeout(dodge, 200); }
  window.addEventListener('scroll', queueDodge, { passive: true });
  window.addEventListener('resize', function () { liftAbovePreviewBar(); queueDodge(); });
  try { new MutationObserver(function (recs) { for (var i = 0; i < recs.length; i++) if (!root.contains(recs[i].target)) return queueDodge(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'style', 'aria-hidden'] }); } catch (err) {}
  document.addEventListener('click', queueDodge, true);
  liftAbovePreviewBar(); queueDodge(); setTimeout(function () { liftAbovePreviewBar(); queueDodge(); }, 1600);
})();
